(function() {
    'use strict';
    angular
        .module('receiptApp')
        .factory('ReceiptService', ReceiptService);

    ReceiptService.$inject = ['$resource', 'DateUtils' ,'$q', '$http', 'GLOBAL_URL'];

    function ReceiptService ($resource, DateUtils, $q, $http, GLOBAL_URL) {
    	
        return $resource(GLOBAL_URL + 'api/ga/receipt/:uri',{uri: '@uri'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                transformResponseError: function(error){
                	if(error.status === 0){
                		alert('There is a problem connecting to the server. Is the server probably down?!');
                	}
                	 return $q.reject(error);
                }
            },
            'returnValue': {
                method: 'GET',
                transformResponse: [function (data) {
                    return  { response: data };
                }],
                transformResponseError: function(error){
                	if(error.status === 0){
                		alert('There is a problem connecting to the server. Is the server probably down?!');
                	}
                	 return $q.reject(error);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    //data.receiptAgDate = DateUtils.convertLocalDateToServer(data.receiptAgDate);
                    return angular.toJson(data);
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'getAgent': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'cancelReason': {
                method: 'GET',
                transformRequest: function (data) {
                    //data.receiptAgDate = DateUtils.convertLocalDateToServer(data.receiptAgDate);
                    return angular.toJson(data);
                },
                transformResponseError: function(error){
                	if(error.status === 0){
                		alert('There is a problem connecting to the server. Is the server probably down?!');
                	}
                	 return $q.reject(error);
                }
            },
            'post': {
	                method: 'POST',
	                transformRequest: function (data) {
	                    //data.receiptAgDate = DateUtils.convertLocalDateToServer(data.receiptAgDate);
	                    return angular.toJson(data);
	                }
            },
            'download': {
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: [function (data,header) {
                	var header = header();
                	downLoad(data,header['file-type'],header['file-export']);
                }],
            },
            'checkThirdPartyFiserv': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                },
                transformResponseError: function(error){
                    if(error.status === 0){
                        alert('There is a problem connecting to the server. Is the server probably down?!');
                    }
                    return $q.reject(error);
                }
            },
        });
    }
    
    
    function downLoad(response, type, fileName) {
		var file = new Blob([response], {type: type});
	  if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
           window.navigator.msSaveBlob(file, fileName);
       } else { // for other browsers
    	   var fileURL = window.URL.createObjectURL(file);
    	   // Test tren chorme va firefox
    		 	var theAnchor = $('<a />')  
		        .attr('href', fileURL)  
		        .attr('download',fileName)
		         .appendTo('body');
			    theAnchor[0].click();   
			    theAnchor.remove();  
    	   //var aTag = document.createElement("a");
    	   	 //aTag.style.cssText = "display: none";
    		/* aTag.style = "display: none";*/
    		/* aTag.href = fileURL;
    		 aTag.download = fileName;
    		 aTag.click();*/
       }
	
};
})();
